import React from 'react';

const Footer = () => (
  <footer className="readmin-footer">
    <p className="no_margin">Copyright © Theralytics 2017 - {new Date().getFullYear()} (Ver. 10.8.6)</p>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer.js